import React from "react";
import { RegionsRiskTopbar } from "./RegionsRiskTopbar";
import { RegionalHeatMap } from "./RegionalHeatMap";
import { RiskFilters } from "./RiskFilters";
import { MetroBreakdown } from "./MetroBreakdown";
import { ConcentrationRiskSummary } from "./ConcentrationRiskSummary";

interface RegionsRiskProps {
  onSidebarToggle: () => void;
}

export const RegionsRisk: React.FC<RegionsRiskProps> = ({
  onSidebarToggle,
}) => {
  return (
    <div className="p-6 pb-8 flex flex-col gap-6">
      <RegionsRiskTopbar onSidebarToggle={onSidebarToggle} />

      <section className="grid grid-cols-[2.6fr_1.6fr] gap-3.5 items-stretch max-lg:grid-cols-1">
        <RegionalHeatMap />
        <RiskFilters />
      </section>

      <section className="grid grid-cols-[2.6fr_1.6fr] gap-3.5 mt-1.5 max-lg:grid-cols-1">
        <MetroBreakdown />
        <ConcentrationRiskSummary />
      </section>
    </div>
  );
};
